export default __webpack_public_path__ + "static/gillord-c405a8dcfbcc73319b837d0bf88988f2.jpg";